import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Service Areas',
    href: '#areas'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md py-2' : 'bg-transparent py-6'}`} data-id="element-114">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-115">
        <div className="flex justify-between items-center" data-id="element-116">
          {/* Logo */}
          <a href="#home" className="flex items-center gap-3 group" data-id="element-117">
            <div className={`transition-all duration-500 rounded-xl p-2 ${isScrolled ? 'bg-transparent opacity-100 translate-y-0' : 'bg-white/10 backdrop-blur-sm opacity-0 -translate-y-2 pointer-events-none'}`} data-id="element-118">
              <img src="https://cdn.magicpatterns.com/uploads/dnNE8vYvCbb9Fr9EoxG2E4/Photoroom_20260503_132729.png" alt="Manny's The Green Mountain Landscaping Logo" className="w-auto object-contain transition-all duration-500 h-12" data-id="element-119" />
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-120">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`relative font-medium transition-colors duration-300 group ${isScrolled ? 'text-gray-800 hover:text-forest' : 'text-white hover:text-gold'}`} data-id="element-121">
                {link.name}
                <span className={`absolute -bottom-1 left-0 w-0 h-0.5 transition-all duration-300 group-hover:w-full ${isScrolled ? 'bg-forest' : 'bg-gold'}`} data-id="element-122"></span>
              </a>)}
            <a href="#contact" className={`px-6 py-2.5 rounded-lg font-semibold transition-all duration-300 shadow-sm hover:shadow-md ${isScrolled ? 'bg-gold hover:bg-gold-dark text-white' : 'bg-white/20 hover:bg-white/30 backdrop-blur-md text-white border border-white/30'}`} data-id="element-123">
              Free Estimate
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button className={`md:hidden p-2 rounded-lg transition-colors ${isScrolled ? 'text-gray-800 hover:bg-gray-100' : 'text-white hover:bg-white/20'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-124">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-125" /> : <MenuIcon className="w-6 h-6" data-id="element-126" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <div className={`md:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-100 shadow-xl transition-all duration-300 origin-top ${isMobileMenuOpen ? 'scale-y-100 opacity-100' : 'scale-y-0 opacity-0'}`} data-id="element-127">
        <div className="flex flex-col px-4 py-6 space-y-4" data-id="element-128">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-800 font-medium text-lg py-2 border-b border-gray-50 hover:text-forest transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-129">
              {link.name}
            </a>)}
          <a href="#contact" className="bg-gold hover:bg-gold-dark text-white px-6 py-3 rounded-lg font-semibold text-center mt-4 transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-id="element-130">
            Free Estimate
          </a>
        </div>
      </div>
    </header>;
}